import { useState } from 'react';
import { TELEGRAM_BOT_URL } from '@/domain/constants';

export function TelegramRequiredScreen() {
  const [copied, setCopied] = useState(false);

  const handleOpen = () => {
    window.location.href = TELEGRAM_BOT_URL;
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(TELEGRAM_BOT_URL);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      const textArea = document.createElement('textarea');
      textArea.value = TELEGRAM_BOT_URL;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    }
  };

  return (
    <div className="flex h-full flex-col items-center justify-center gap-6 p-6 text-center">
      <div className="flex flex-col items-center gap-4">
        <img src="/xcoin.png" alt="X" className="h-20 w-20" draggable={false} />
        <h1 className="text-2xl font-bold uppercase tracking-wider text-white">
          Open in Telegram
        </h1>
        <p className="max-w-sm text-sm leading-relaxed text-gray-300">
          This is a Telegram Mini App. Please open it from Telegram (inside the bot), otherwise
          authentication won’t work.
        </p>
      </div>

      <div className="flex w-full max-w-sm flex-col gap-3">
        <button
          onClick={handleOpen}
          className="w-full rounded py-3 text-sm font-semibold uppercase tracking-wide text-white transition-all active:scale-[0.98]"
          style={{
            background: 'linear-gradient(135deg, #00a2ff, #06b6d4)',
            border: '1px solid rgba(6, 182, 212, 0.5)',
            boxShadow: '0 0 20px rgba(0, 162, 255, 0.25)',
          }}
        >
          Open Telegram Bot →
        </button>

        <button
          onClick={handleCopy}
          className="w-full rounded py-3 text-sm font-medium transition-all active:scale-[0.98]"
          style={{
            background: copied ? 'rgba(34, 197, 94, 0.25)' : 'rgba(23, 37, 84, 0.25)',
            border: copied
              ? '1px solid rgba(34, 197, 94, 0.45)'
              : '1px solid rgba(6, 182, 212, 0.25)',
            color: copied ? 'rgb(187, 247, 208)' : 'rgb(165, 243, 252)',
          }}
        >
          {copied ? 'Copied' : 'Copy bot link'}
        </button>

        <div
          className="rounded p-3 text-xs text-gray-400"
          style={{
            background: 'rgba(23, 37, 84, 0.15)',
            border: '1px solid rgba(6, 182, 212, 0.15)',
          }}
        >
          Link: <span className="font-mono text-gray-200">{TELEGRAM_BOT_URL}</span>
        </div>
      </div>
    </div>
  );
}
